/** Общий вид меню CRM и «открыть ▾» полосы выбора «Планов»: кнопка, строка панели и
 *  расчёт места панели. Вынесено из `SmartButtons.tsx` без изменений. */

export const СТРОКА =
  "flex w-full items-center justify-between gap-3 px-3 py-1 text-left text-[12.5px] hover:bg-bg-hover focus-visible:bg-bg-hover focus-visible:outline-none";
const КНОПКА_ВИД = "flex h-7 items-center rounded-[var(--radius-ui)] border border-border bg-bg text-[12.5px]";
export const КНОПКА = `${КНОПКА_ВИД} gap-1 px-2`;
/** Та же рамка и стрелка, на 6 px уже (поля и зазор): «открыть ▾» в полосе
 *  выбора «Планов», где на 1280 px с открытым меню слева место впритык. */
export const КНОПКА_УЗКАЯ = `${КНОПКА_ВИД} gap-0.5 px-1.5`;
export const ШИРИНА = 260;
/** Зазор панели от кнопки (`mb-1`) и от верха `main`. */
export const ЗАЗОР = 4;
export const ОТСТУП = 8;
export type Место = { maxHeight: number; right: boolean };

/** Где поместится панель: высота — от кнопки до КРАЯ прокручиваемой области, что
 *  открывается панель ОТ (верх — вверх, как «Товары»; низ — вниз, как «Планы»),
 *  край — левый у кнопки, а у правого края области правый: иначе панель ушла бы
 *  в горизонтальную прокрутку `main`. Области нет (кнопка вне раздела) — окно. */
export function место(кнопка: HTMLElement, down: boolean): Место {
  const b = кнопка.getBoundingClientRect();
  const область = кнопка.closest("main");
  const r = область?.getBoundingClientRect();
  const верх = r ? r.top : 0;
  const низ = r ? r.bottom : window.innerHeight;
  const левый = r ? r.left : 0;
  const правый = область && r ? r.left + область.clientWidth : window.innerWidth;
  const влево = b.left + ШИРИНА > правый - ОТСТУП && b.right - ШИРИНА >= левый + ОТСТУП;
  const высота = down ? низ - b.bottom - ЗАЗОР - ОТСТУП : b.top - верх - ЗАЗОР - ОТСТУП;
  return { maxHeight: Math.max(120, Math.floor(высота)), right: влево };
}
